export const DEFAULT_TIMEZONE = "America/Sao_Paulo";

const LOCALE_BY_LANGUAGE = {
  pt: "pt-BR",
  en: "en-US",
  es: "es-ES",
};

export function getLocaleForLanguage(languageCode) {
  return LOCALE_BY_LANGUAGE[languageCode] || LOCALE_BY_LANGUAGE.pt;
}

export function getBrowserTimezone() {
  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    if (timeZone) {
      return timeZone;
    }
  } catch (_err) {
    /* ignore */
  }
  return DEFAULT_TIMEZONE;
}

function hasExplicitTimezone(value) {
  const trimmed = String(value).trim();
  return /[zZ]$/.test(trimmed) || /[+-]\d{2}:?\d{2}$/.test(trimmed);
}

function isNaiveIsoDateTime(value) {
  const normalized = String(value).trim().replace(" ", "T");
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(normalized);
}

function toDate(value) {
  if (value instanceof Date) {
    return value;
  }
  if (value == null || value === "") {
    return null;
  }

  const trimmed = String(value).trim();

  if (hasExplicitTimezone(trimmed)) {
    const date = new Date(trimmed);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  if (isNaiveIsoDateTime(trimmed)) {
    const normalized = trimmed.replace(" ", "T");
    const date = new Date(`${normalized}Z`);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateInTimezone(
  value,
  { locale = "pt-BR", timezone = getBrowserTimezone(), options = {} } = {},
) {
  const date = toDate(value);
  if (!date) {
    return value == null ? "" : String(value);
  }

  return date.toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: timezone,
    ...options,
  });
}

export function formatDateTimeInTimezone(
  value,
  {
    locale = "pt-BR",
    timezone = getBrowserTimezone(),
    options = {},
    emptyValue = null,
  } = {},
) {
  if (value == null || value === "") {
    return emptyValue;
  }

  const date = toDate(value);
  if (!date) {
    return String(value);
  }

  return date.toLocaleString(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: timezone,
    ...options,
  });
}
